import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
export default class ViewState {
  constructor(props, state) {
    _defineProperty(this, "_viewportProps", void 0);

    _defineProperty(this, "_state", void 0);

    this._viewportProps = this.applyConstraints(props);
    this._state = state;
  }

  getViewportProps() {
    return this._viewportProps;
  }

  getState() {
    return this._state;
  }

}
//# sourceMappingURL=view-state.js.map